import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";

type ScoreLineType = {
  percentage?: string;
};

export const ContentWrapper = styled.div`
  font-family: ${typography.fontFamily};
`;
export const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 27px;
  color: ${colors.grey};
`;
export const RateLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;
export const RateWrapper = styled.div``;
export const Score = styled.div`
  margin-left: 17px;
  font-size: 16px;
  color: ${colors.grey};
`;
export const ScoreLine = styled.div<ScoreLineType>`
  margin-left: 16px;
  width: 127px;
  height: 8px;
  border-radius: 6px;
  background-color: ${colors.greyVeryLight};
  position: relative;

  :after {
    content: "";
    position: absolute;
    border-radius: 6px;
    background: ${colors.main};
    top: 0;
    bottom: 0;
    left: 0;
    width: ${(props) => props.percentage};
  }
`;
export const Percentage = styled.div`
  margin-left: 14px;
  min-width: 56px;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.grey};
`;
export const AmountOfRates = styled.div`
  margin-left: 14px;
  color: ${colors.grey};
`;
export const Label = styled.label``;
